import {Table, Form, Space, Radio, Badge, Flex } from 'antd'
import React, { useEffect, useState } from 'react'
import IncomeCheck from './IncomeCheck';
import Copy from '../../cpn/Copy';
import ReportCheck from '../report/ReportCheck';
import classes from './income.module.css';
import StateTag from '../../cpn/StateTag';
import Icon from '../../cpn/Icon';
import IncomeEditReportEdit from './IncomeEditReportEdit';
import IncomeEdit from './IncomeEdit';
function IncomeListSubmitted(props) {
    const [form] = Form.useForm();
    const [list,setList] = useState([]);   
    const [query, setQuery] = useState({
      "ddsr_state": '',     
  });
    useEffect(() => {
        if (props.list) {
            let arr = props.list.filter((item) => (item.ddsr_state === '2' || item.ddsr_state === '3' || item.ddsr_state === '4' || item.ddsr_state === '5' || item.ddsr_state === '6') && item.ddsr_uid === props.yh_id);      
            if(query.ddsr_state){
              if(query.ddsr_state === '5'){
                arr = arr.filter((item) => item.ddsr_state === '5' || item.ddsr_state === '6');                
              }else{
                arr = arr.filter((item) => item.ddsr_state === query.ddsr_state);
              }
            }      
            arr = arr.map((item) => ({
                ...item,
                key: item.key || item.ddsr_id
            }));
            const unread = arr.filter(item => item.ddsr_state === '5');
            const read = arr.filter(item => item.ddsr_state === '2' || item.ddsr_state === '3' || item.ddsr_state === '4' ||  item.ddsr_state === '6');
            read.sort((a, b) => new Date(b.ddsr_state_time) - new Date(a.ddsr_state_time));
            const sortedArr = [...unread, ...read];
            setList(sortedArr);
        }
    }, [props.list, query.ddsr_state, props.yh_id])
    
    const columns = [    
        {
            title: '收款客户',
            dataIndex: 'ddsr_kh_name',
            width: '12%',
            key: 'ddsr_kh_name',         
            render: (text, record) =>{
                if(record.ddsr_state === '4'){
                    if(record.ddsr_bzd_id){
                        return <IncomeEditReportEdit
                            ddsr_id={record.key} 
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            ddsr_bzd_id={record.ddsr_bzd_id}
                            ddsr_bzd_name={record.ddsr_bzd_name}
                            ddsr_kh_id={record.ddsr_kh_id}
                            ddsr_kh_name={record.ddsr_kh_name}
                            ddsr_state={record.ddsr_state}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                        />
                    }else{
                        return <IncomeEdit
                            ddsr_id={record.key} 
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            ddsr_bzd_id={record.ddsr_bzd_id}
                            ddsr_bzd_name={record.ddsr_bzd_name}
                            ddsr_kh_id={record.ddsr_kh_id}
                            ddsr_kh_name={record.ddsr_kh_name}
                            ddsr_state={record.ddsr_state}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                            ddsr_uid={record.ddsr_uid}
                        />
                    }
                   
                }else{
                    return <IncomeCheck
                                type='button'
                                ddsr_id={record.key} 
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                ddsr_bzd_id={record.ddsr_bzd_id}
                                ddsr_price={record.ddsr_price}
                                ddsr_content={record.ddsr_content}
                                ddsr_date={record.ddsr_date}
                                ddsr_date_end={record.ddsr_date_end}
                                ddsr_bzd_name={record.ddsr_bzd_name}
                                ddsr_bzd_danhao={record.ddsr_bzd_danhao}
                                ddsr_type_id={record.ddsr_type_id}
                                ddsr_type_name={record.ddsr_type_name}
                                ddsr_kh_id={record.ddsr_kh_id}
                                ddsr_kh_name={record.ddsr_kh_name}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                ddsr_num={record.ddsr_num}
                                ddsr_amount={record.ddsr_amount}
                                ddsr_state={record.ddsr_state}
                                ddsr_bm_id={record.ddsr_bm_id}
                                ddsr_bm_name={record.ddsr_bm_name}
                                ddsr_khyhzh_id={record.ddsr_khyhzh_id}
                                ddsr_khyhzh_name={record.ddsr_khyhzh_name}
                                ddsr_image_name={record.ddsr_image_name}
                                ddsr_image_file={record.ddsr_image_file}
                                ddsr_ctime={record.ddsr_ctime}
                                ddsr_uid={record.ddsr_uid}
                                listType='submitted'
                            />
                }
            }
        },
        {
            title: '收款金额',
            dataIndex: 'ddsr_amount',
            width: '10%',
            key: 'ddsr_amount',   
            render: (text, record) => <span style={{color:'red'}}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '收款事由',
            dataIndex: 'ddsr_name',
            key:'ddsr_name',
            render:(text) => <Copy title={text}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"ddsr_bzd_danhao",
            key:'ddsr_bzd_danhao',
            render:(text,record) => {
                return <ReportCheck  
                            dsbzd_name={record.ddsr_bzd_name} 
                            dsbzd_id={record.ddsr_bzd_id} 
                            dsbzd_danhao={record.ddsr_bzd_danhao} 
                            yh_id={props.yh_id}  
                            yh_name={props.yh_name} 
                            qy_id={props.qy_id} 
                            qy_name={props.qy_name}
                            dsbzd_uid={record.ddsr_uid}/>
            }
        },   
        {
            title: '审批时间',
            dataIndex: 'ddsr_state_time',
            width: '10%',
            key: 'ddsr_state_time',             
        },
        {
            title: '状态',
            dataIndex: 'ddsr_state',
            width: '5%',
            key: 'ddsr_state',            
            render:(text) => <StateTag state={text} />
        },       
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },       
    ]
    return (
        <>                            
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_income_submitted'
                    form={form}
                    initialValues={{                        
                        ddsr_state: query.ddsr_state ? query.ddsr_state : '',                        
                    }}
                    onFinish={(values) => {
                        console.log(values);
                        // Serialize dayjs objects to strings before storing
                        const serializedValues = {
                            ...values,
                            ddsr_state: values.ddsr_state ? values.ddsr_state : '',
                            ddsr_kh_id: values.ddsr_kh_id ? values.ddsr_kh_id : '',
                            ddsr_name: values.ddsr_name ? values.ddsr_name : '',
                        };
                        
                        localStorage.setItem('jtg-caiwu_incomeList_ddsr_state', JSON.stringify(serializedValues.ddsr_state));
                        localStorage.setItem('jtg-caiwu_incomeList_ddsr_kh_id', JSON.stringify(serializedValues.ddsr_kh_id));
                        localStorage.setItem('jtg-caiwu_incomeList_ddsr_name', JSON.stringify(serializedValues.ddsr_name));
                        setQuery(prev => ({ 
                            ...prev, 
                            dsbzd_state: serializedValues.dsbzd_state, 
                        }));
                    }}
                >
                    <Form.Item 
                        name='dsbzd_state' 
                        label={props.label} 
                        required={props.required} 
                        style={props.style} 
                        wrapperCol={props.wrapperCol}
                        noStyle

                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({ 
                                    ...prev, 
                                    ddsr_state: e.target.value,                                     
                                }));
                                localStorage.setItem('jtg-caiwu_incomeList_ddsr_state', JSON.stringify(e.target.value));
                            }}
                            buttonStyle='solid'
                            optionType="button" 
                        >
                            <Radio value='' >全部</Radio>
                            <Radio value='2' >待审批</Radio>
                            <Radio value='3' >审批中</Radio>                
                            <Badge count={props.ddsrRejectedNum} style={{zIndex:'9999'}} >
                                <Radio value='4' >已驳回</Radio>
                            </Badge>
                            <Badge count={props.ddsrEndNeedReadNum} style={{zIndex:'9999'}}>
                                <Radio value='5' >已结束</Radio>
                            </Badge>
                        </Radio.Group>        
                    </Form.Item>                    
                    <Form.Item style={{marginLeft: 10}}>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                    localStorage.setItem('jtg-caiwu_incomeList_ddsr_state', JSON.stringify(''))
                                    setQuery({
                                        "ddsr_state": '',                                        
                                    })
                                    form.setFieldsValue({
                                        ddsr_name: null,
                                        ddsr_kh_id: null,
                                        ddsr_bzd_danhao: null,
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>  
            </Flex>
            <Table 
                className={classes.pinkHeader}
                dataSource={list}
                columns={columns}
                pagination={{
                    pageSize: 100,
                    pageSizeOptions: [100, 200, 500, 1000],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `共 ${total} 条`,
                    
                }}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1} colSpan={1}>
                                <span style={{color:'red'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无收款数据' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default IncomeListSubmitted